<template>
    <div>
        <v-card>
            <v-card-title>
                <span class="headline">{{label}}</span>
            </v-card-title>

            <v-card class="pa-2">
                <v-row>
                    <v-col cols="12" sm="6">
                    <v-text-field 
                    label="Title*" required
                    :counter="caseRules.title.max"
                    :rules="titleRules"
                    v-model="ccase.title"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                    <v-menu
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        max-width="290"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="computedDateFormatted"
                            clearable
                            label="Date Completed"
                            readonly
                            v-on="on"
                            @click:clear="date = null"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="ccase.dateAdded"
                        @change="dateMenu = false"
                        ></v-date-picker>
                    </v-menu>
                    </v-col>
                    <!-- Categories are auto made-up based on the treatment items added as part of this ccase, as are images -->
                    <v-col cols="12">
                        <v-textarea
                            solo
                            name="description"
                            label="Description"
                            :counter="caseRules.description.max"
                            :rules="descriptionRules"
                            v-model="ccase.description"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <!-- A box that displays that treatment with a plus button action-->
                        <v-card v-if="Object.keys(currentSelectedTreatment).length !== 0" outlined> 
                        <v-card-title class="headline">Selected Treatment: {{currentSelectedTreatment.title}}</v-card-title>
                        <v-card-subtitle>By: {{currentSelectedTreatment.ownerName}}</v-card-subtitle>
                        <v-card-text>{{currentSelectedTreatment.description}}</v-card-text>
                        <v-avatar
                            class="ma-3"
                            size="125"
                            tile
                        >
                            <v-img :src="currentSelectedTreatment.previewImage"></v-img>
                        </v-avatar>
                        <v-card-actions>
                            <v-btn @click="addTreatmentToCase()"><v-icon right>mdi-plus-box</v-icon>Add Treatment to Case</v-btn>
                        </v-card-actions>
                        </v-card>
                        <!-- Quick Treatment Search -->
                        <quick-treatment-search
                        label="Search for treatments"
                        :orgId="$route.params.userDb.orgid"
                        :uid="$route.params.userDb.uid"
                        type="Case"
                        :focusEffect="false"
                        v-on:caseTreatmentEmit="updateTreatmentValue($event)"></quick-treatment-search>
                        <!-- A data table that shows those treatments that have been added so far -->
                        <v-data-table
                        :headers="[{text: 'Title', value: 'title'}, {text: 'Category', value: 'category'}, {text: 'Owner', value: 'ownerName'}, {text: 'Remove', value: 'remove'}]"
                        :items="ccase.treatments"
                        sort-by="name"
                        class="elevation-1"
                        hide-default-footer
                        dense
                        >
                        <template v-slot:item.title="{ item }">
                          {{getTreatmentTitle(item)}}
                        </template>
                        <!-- Column to remove from the data table -->
                        <template v-slot:item.remove="{ item }">
                          <v-btn icon @click.stop="removeTreatmentFromCase(item)">
                            <v-icon color="red lighten-1">mdi-window-close</v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                
                </v-card>

                <v-card flat>
                    <v-card-text>
                    <v-row justify="space-between" no-gutters>
                        <v-col cols="12" md="4">
                        <small>*Indicates required field</small>
                        </v-col>
                        <v-col cols="12" md="6">
                        <v-row>
                            <v-checkbox label="I have read and accepted the terms and conditions" v-model="termsAccepted">
                            <template v-slot:label>
                                <div>
                                I have read and accepted
                                    <a
                                    color="primary"
                                    @click.stop="tcDialog=true"
                                    >
                                    Terms and Conditions
                                    </a>
                                </div>
                            </template>
                            </v-checkbox>
                            <v-dialog v-model="tcDialog"  persisitent width="600px">
                            <v-card>
                                <v-card-title>
                                <span class="headline">Case Terms and Conditions</span>
                                </v-card-title>
                                <v-card-text v-text="termsConditions"></v-card-text>
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="disagreeTerms()">Disagree</v-btn>
                                <v-btn color="primary" text @click="agreeTerms()">Agree</v-btn>
                                </v-card-actions>
                            </v-card>
                            </v-dialog>
                        </v-row>
                        </v-col>
                    </v-row>
                    </v-card-text>
                </v-card>
            <v-card-actions>
                <v-switch v-model="ccase.public" inset label="Public?" class="pl-4"></v-switch>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="cancelCase()">Cancel</v-btn>
                <v-btn color="primary" text @click="saveCase()">Save Case</v-btn>
            </v-card-actions>
        </v-card>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import firebase from '@/fb';
import Case from './../case.js';
import CaseRules from './../config/caseRules';
import TermsConditions from './../../../termsconditions';
import moment from 'moment';
import QuickTreatmentSearch from './../../Treatments/Search/QuickTreatmentSearch.vue'
import Activity from './../../Management/ActivityTracker/activity.js'
import TreatmentDataService from './../../../services/treatmentDataService.js'
import Toast from './../../../plugins/customToast.js';

export default {
    name: 'addCasePopup',
    components: {
      QuickTreatmentSearch
    },
    props: {
      label: String,
      editMode: Boolean,
      originalCase: Object
    },
    methods: {      
      async saveCase(){
        var that = this;

        //Build the rest of the 'case' object by looping through the treatment objects to get the total upvotes and overall categories
        if (this.ccase.treatments.length > 0){
            var upvoteValue = 0;
            //Loop through each of our treatments
            this.ccase.treatments.forEach(function (treatment){
              //Guard against deleted treatments
              if (!treatment.deleted) {
                //Check if the treatment has any categories
                if (treatment.category.length > 0){
                    treatment.category.forEach(function (category){
                      //Looping through each of those categories, check if it is already in our case category list
                      if (!that.ccase.category.includes(category)){
                        that.ccase.category.push(category);
                      }
                    });
                  }
                //Calculate the total upvotes (Every time an upvote is made to a treatment, it should propagate up and update this upvote count as well)
                upvoteValue += treatment.upvotes;
              }
            });
          //Set the new upvote value
          this.ccase.upvotes = upvoteValue;            
        }

        //If this is in edit mode, check if the treatments have been modified (we don't need to revalidate it if they remain the same) --> If so, we will have to update the treatments 'Case' boolean (all they need to know is if they are a part of a case or not.... Not specifically which case)
        if (!this.editMode){
          //If not edit mode add in the user info (This may need to be cleaned up in the future pushed into a function?)
          this.ccase.organisation = this.$route.params.orgDb.id;
          this.ccase.ownerName = this.$route.params.userDb.displayname;
          this.ccase.owner = this.$route.params.userDb.uid;
          //Set dateAdded + lastModified to now
          this.ccase.dateAdded = moment(new Date()).format('MM-DD-YYYY hh:mm A');
          this.ccase.dateAddedTimestamp = moment(new Date()).unix();
          this.ccase.lastModified = moment(new Date()).format('MM-DD-YYYY hh:mm A');
          this.ccase.lastModifiedTimestamp = moment(new Date()).unix();
        } else {
          //Just set the dateModified to now
          this.ccase.lastModified = moment(new Date()).format('MM-DD-YYYY hh:mm A');
          this.ccase.lastModifiedTimestamp = moment(new Date()).unix();
        }
        var valid;

        //Check that the terms and conditions have been accepted
        if (this.termsAccepted) {
          valid = await this.ccase.validateCase(this.caseRules, this.$route.params.userDb.uid)
        } else {
          //If they weren't accepted, push an error
          valid = {result: false, errorMessage: "You must read and accept the terms and conditions to add a case"}
        }
        
        if (valid !== true){
          //If the validation is rejected, show the usual Sweet Alert errors
          swal.fire({title: `Error adding to the database`, text: `Your case had the following issues: \n${valid.errorMessage}`, icon: "error", showConfirmButton: true, confirmButtonText: "Got it!"})
        } else {
          var addReference;
          
          if (this.editMode){
            addReference = firebase.db.collection('cases').doc(this.originalCase.id).update(JSON.parse(JSON.stringify(this.ccase)));
          } else {
            addReference = firebase.db.collection('cases').add(JSON.parse(JSON.stringify(this.ccase)));
          }

          addReference
          .then(async function(caseRef) {            
            //Depending on the add reference, we need our current documents Id:
            var caseId = null;

            if (that.editMode) {
              caseId = that.originalCase.id;
            } else {
              caseId = caseRef.id;
            }

            //If the object is in edit mode and changed, update the treatments 'Case' boolean. Otherwise, just always update the treatments 'Case' boolean
            that.updateTreatmentCaseStatus(that.ccase.treatments, caseId);

            if (that.editMode){
              //Push the activity to the tracker
              that.activity = new Activity("Edited", {type: "Case", id: caseId}, moment(new Date()).format('MM-DD-YYYY hh:mm A'));
              that.activity.pushActivityToFirebase(that.$route.params.userDb.uid);
              swal.fire({title: `Successfully Edited Case!`, text: `${that.ccase.title} was edited in your organisations cases list`, icon: "success", showConfirmButton: false});
            } else {
              //Push the activity to the tracker
              that.activity = new Activity("Created", {type: "Case", id: caseId}, moment(new Date()).format('MM-DD-YYYY hh:mm A'));
              that.activity.pushActivityToFirebase(that.$route.params.userDb.uid);
              swal.fire({title: `Successfully Saved Case!`, text: `${that.ccase.title} was saved to your organisations cases list`, icon: "success", showConfirmButton: false});
            }
          
            that.closeDialog();
          })
          .catch(function(error) {
            swal.fire({title: `Error adding to the database`, text: "Error: " + error, icon: "error", showConfirmButton: false});
          });
        }
      },
      cancelCase(){
        this.closeDialog();
      },
      updateTreatmentValue(treatment){
        //Normal interaction that will update our current treatment object with the emitted value
        if (treatment.id != null){
          this.currentSelectedTreatment = treatment;
        }
      },
      async updateTreatmentCaseStatus(treatments, caseId){
        var that = this;
        //This will modify the treatments 'Case' value to true (we won't need to know the exact cases, instead we would utilise a query to discover what cases it is a part of)
        //The relationship between Case and Treatment is many to many, however we could pass the caseRef id in if we wanted (either way, the search will still end up being required?)
        if (this.ccase.treatments.length > 0){
            //Loop through each of our treatments
            treatments.forEach(async function (treatment){
              var updateObject;
              //If the treatment doesn't yet have its case flag marked as true, do so
              if (treatment.case){
                if (!treatment.case.value){
                  updateObject = { case: { value: true, parentCases: [caseId] } }
                } else {           
                  updateObject = { case: { value: true, parentCases: [...treatment.case.parentCases, caseId] } }
                }
              } else {
                updateObject = { case: { value: true, parentCases: [caseId] } }
              }
              //Then try to push the downloadURL to the firebase treatment.images array
              var result = await that.treatmentDataService.updateFirebaseById('treatments', treatment.id, updateObject);
              console.log(result); //eslint-disable-line
            });
        }
      },
      getTreatmentTitle(treatment) {
        if (treatment.deleted) {
          return "Treatment Deleted";
        }
        else {
          return treatment.title;
        }
      },
      addTreatmentToCase(){
        var that = this;

        var addFail = false;
        if (this.currentSelectedTreatment != null){
            //Check that the treatment doesn't already exist in the cases list
            this.ccase.treatments.forEach(function (treatment){
                if (that.currentSelectedTreatment.id === treatment.id){
                    addFail = true;
                }
            });

            if (addFail){
                Toast.fire({  icon: 'error',  title: `Failed to add treatment to case`});
            } else {
                this.ccase.treatments.push(this.currentSelectedTreatment);
                Toast.fire({  icon: 'success',  title: `Successfully added treatment to case`});
            }
        }
      },
      removeTreatmentFromCase(arrayItem){
        //Filter out of the array
        this.ccase.treatments = this.ccase.treatments.filter(treatment => treatment.id !== arrayItem.id);
      },
      dialogShown(){
        if (this.editMode && this.originalCase){
          var oCase = this.originalCase;
          //If it is the editing, set the current case to the one that was propped in
          this.ccase = new Case(oCase.data.title, oCase.data.description, oCase.data.comments, oCase.data.dateAdded, oCase.data.dateAddedTimestamp, oCase.data.category, oCase.data.organisation, oCase.data.ownerName, oCase.data.owner, oCase.data.public, oCase.data.upvotes, oCase.data.lastModified, oCase.data.lastModifiedTimestamp, oCase.data.treatments);
        } else {
          //Otherwise, define it as a new one
          this.resetDialog()
          this.ccase.organisation = this.$route.params.orgDb.id;
          this.ccase.ownerName = this.$route.params.userDb.displayname;
          this.ccase.owner = this.$route.params.userDb.uid;
        }
      },
      agreeTerms(){
        this.termsAccepted = true;
        this.tcDialog = false;        
      },
      disagreeTerms(){
        this.termsAccepted = false;
        this.tcDialog = false;
      },
      closeDialog(){
        //This shall emit something to close the dialog and call the reset
        this.resetDialog();

        this.$emit("dialogClosed");
      },
      resetDialog(){
        //Function than can be called on completion, close and load to reset the dialog
        this.currentSelectedTreatment = {};

        //Set back to a blank case
        this.ccase = new Case();
      },
    },
    mounted() {
      this.treatmentDataService = new TreatmentDataService();
    },
    computed: {
        titleRules () {
            const titleRules = [];

            if (this.caseRules.title.max) {
              const rule =
              v => (v || '').length <= this.caseRules.title.max || `A maximum of ${this.caseRules.title.max} characters are allowed` 
              titleRules.push(rule)
            }
            if (this.caseRules.title.min) {
              const rule =
              v => (v || '').length >= this.caseRules.title.min || `A minimum of ${this.caseRules.title.min} characters are required`
              titleRules.push(rule)
            }                           
            return titleRules;
        },
        descriptionRules(){
          const descriptionRules = [];

            if (this.caseRules.description.max) {
              const rule =
              v => (v || '').length <= this.caseRules.description.max || `A maximum of ${this.caseRules.description.max} characters are allowed for the description` 
              descriptionRules.push(rule)
            }
            if (this.caseRules.description.min) {
              const rule =
              v => (v || '').length > this.caseRules.description.min || `A minimum of ${this.caseRules.description.min} characters are required for the description`
              descriptionRules.push(rule)
            }                           
            return descriptionRules;
        },
        computedDateFormatted () {
          return this.ccase.dateAdded ? moment(this.ccase.dateAdded).format('dddd, MMMM Do YYYY') : ''
        },
    },
    watch: {
      originalCase: { 
        // the callback will be called immediately after the start of the observation
        immediate: true, 
        handler (val) {
          if (val){
            this.dialogShown();
          }
        }
      }
    },
    data: () => ({
        storageRef: "",
        dialog: false,
        ccase: new Case(),
        caseRules: CaseRules,
        dateMenu: false,
        termsAccepted: false,
        tcDialog: false,
        termsConditions: TermsConditions,
        currentSelectedTreatment: {}
    })
}
</script>

<style scoped>
.swal-footer {
  background-color: rgb(245, 248, 250);
  margin-top: 32px;
  border-top: 1px solid lightgreen;
  overflow: hidden;
}

.swal-button {
  padding: 2px 5px;
  border-radius: 2px;
  background-color: lightgreen;
  font-size: 12px;
  border: 1px solid lightgreen;
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
}

.swal-modal {
  background-color: rgba(63,255,106,0.69);
  border: 3px solid white;
}
</style>